import Head from "next/head";
import { GalleryLanding } from "components/organisms/GalleryLanding";
export default function GalleryPage() {
  return <>
            <Head data-sentry-element="Head" data-sentry-source-file="index.tsx">
                <title>
                    CharGen Gallery: AI Generated Images of Characters, NPCs,
                    and Monsters
                </title>
                <meta name="description" content="DnD Character Creator, Monster Generator. AI Generated Images for your D&D Characters and Monster Art within seconds. Create AI Generated Images for free." data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta property="og:url" key="og:url" content="https://char-gen.com/gallery" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta property="og:description" key="og:description" content="DnD Character Creator, Monster Generator. AI Generated Images for your D&D Characters and Monster Art within seconds. Create AI Generated Images for free." data-sentry-element="meta" data-sentry-source-file="index.tsx" />
            </Head>
            <GalleryLanding data-sentry-element="GalleryLanding" data-sentry-source-file="index.tsx" />
        </>;
}